import { Injectable, signal } from '@angular/core'

import { DEFAULT_LANGUAGE, DEFAULT_LOCALE, localeToCurrencyMap } from '@flowx/core-sdk'

@Injectable({ providedIn: 'root' })
export class LocaleService {
  locales = signal<string[]>(Object.keys(localeToCurrencyMap))
  selectedLocale = signal<string>(DEFAULT_LOCALE)
  selectedLanguage = signal<string>(DEFAULT_LANGUAGE)

  selectLocale(locale: string): void {
    this.selectedLocale.set(locale)
  }

  selectLanguage(language: string): void {
    this.selectedLanguage.set(language)
  }
}
